import { createBrowserClient } from "@supabase/ssr";
import { Database } from "../../types/supabase";
import { SupabaseClient } from "@supabase/supabase-js";
import { isLocalBypassAuthEnabled } from "@/lib/local-bypass-auth";

let browserClient: SupabaseClient<Database> | null = null;

export function getBrowserClient() {
  if (browserClient) return browserClient;

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !key) {
    if (isLocalBypassAuthEnabled()) {
      return (browserClient = createBrowserClient<Database>(
        "https://example.supabase.co",
        "eyJhbGciOiJIUzI1NiJ9.placeholder",
      ));
    }
    throw new Error(
      "@supabase/ssr: Your project's URL and API key are required to create a Supabase client!",
    );
  }

  browserClient = createBrowserClient<Database>(url, key);
  return browserClient;
}

export const getSupabaseClient = () => getBrowserClient();
export default getSupabaseClient;
